import { useContext } from "react";
import Axios from "axios";
import { ConfiguratorContext } from "../context";

/**
 * Hook para manejo de datos de concesionarios
 * Permite obtener la lista de concesionarios y manejar la selección
 */
const useDealershipsData = () => {
    const [state, setState] = useContext(ConfiguratorContext);

    // Obtiene la lista de concesionarios desde la API
    const getDealerships = async () => {
        setState((prevState) => ({
            ...prevState,
            dealershipsLoading: true,
        }));

        try {
            const response = await Axios.get(`/api/vehicles/bnp/dealerships`);

            setState((prevState) => ({
                ...prevState,
                dealerships: response.data,
            }));
        } finally {
            // en finally: si la request falla igual hay que sacar el skeleton
            setState((prevState) => ({
                ...prevState,
                dealershipsLoading: false,
            }));
        }
    };

    // Establece el concesionario seleccionado
    const setSelectedDealership = (dealership, callback = () => {}) => {
        setState(
            (prevState) => ({
                ...prevState,
                selectedDealership: dealership,
            }),
            callback()
        );
    };

    // Guarda la ubicación del usuario para ordenar por cercanía y mandar la distancia
    // con el lead
    const setUserPosition = (position) => {
        setState((prevState) => ({
            ...prevState,
            userPosition: position,
        }));
    };

    return {
        getDealerships,
        setSelectedDealership,
        setUserPosition,
        selectedDealership: state.selectedDealership,
        dealerships: state.dealerships,
        dealershipsLoading: state.dealershipsLoading,
        userPosition: state.userPosition,
    };
};

export default useDealershipsData;
